import styled from 'styled-components';
import { InputField } from 'lib/iterable-hook-form/FormField/InputField';
import { useFormContext, useFormState } from 'react-hook-form';
import { FormField } from 'ui/formField';
import { spacing } from 'ui/theme';
import { InfoBanner } from 'ui/banner';
import { GoalEventType } from 'modules/goals/types';
// import { Link } from 'ui/links';
import { CreateGoalFormValues } from './CreateGoalFormProvider';
// import { ApplyGoalToField } from './ApplyGoalToField';
// import { AttributionMethodField } from './AttributionMethodField';
import {
  CREATE_GOAL_FORM_TEST_IDS,
  EVENT_NAME_FIELD,
  EVENT_TYPE_DELIMITER,
  GOAL_NAME_FIELD,
} from './CreateGoalForm.constants';
import { EventField } from './EventField';

const StyledInfoBanner = styled(InfoBanner)`
  width: 100%;
  margin-top: ${spacing.plusHalf};
`;

export const CreateGoalForm = () => {
  const { errors } = useFormState<CreateGoalFormValues>();

  const { watch } = useFormContext();
  const eventName = watch(EVENT_NAME_FIELD);

  const nameErrorMessage = errors?.[GOAL_NAME_FIELD]?.message;
  const metricErrorMessage = errors?.[EVENT_NAME_FIELD]?.message;

  const [eventType] = eventName?.split(EVENT_TYPE_DELIMITER) ?? [];
  const isPurchaseEventSelected = eventType === GoalEventType.Purchase;
  const isCustomEventSelected = eventType === GoalEventType.CustomEvent;

  const showBanner = eventName && (isPurchaseEventSelected || isCustomEventSelected);

  return (
    <>
      <FormField labelText="Goal name" hasError={!!nameErrorMessage} errorText={nameErrorMessage}>
        <InputField
          data-test={CREATE_GOAL_FORM_TEST_IDS.NAME}
          name={GOAL_NAME_FIELD}
          placeholder='Example: "Boost email engagement"'
        />
      </FormField>
      <FormField labelText="Event" hasError={!!metricErrorMessage} errorText={metricErrorMessage}>
        <EventField />
      </FormField>

      {showBanner && (
        <StyledInfoBanner>
          During this beta period, you'll need to add this custom event as conversions in your
          campaigns to view performance for this goal.
          {/* <Link
            variant="inherit"
            // TODO: Add correct support article link once available
            href="https://support.iterable.com/hc/en-us/articles/1150000000000000000"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more
          </Link> */}
        </StyledInfoBanner>
      )}

      {/* NOTE: These are not yet supported. */}
      {/* <FormField labelText="Attribution method">
        <AttributionMethodField />
      </FormField>
      <FormField labelText="Apply goal to">
        <ApplyGoalToField />
      </FormField> */}
    </>
  );
};
